export default Object.freeze({
  '2016-2017': 19,
})
